<template>
    <div> 
        <div class="left-menu  ">
            <div class="content-logo"> 
                <span>
                  {{$t('FxViewTradAPI')}}
                  <!-- <small class="badge badge-pill badge-success">Version 0-1</small> -->
                </span>
            </div>
            <div class="content-menu scrollbar">
                <h4><a href="#" >{{$t('Introduction')}}</a></h4>
                <ul class="listPre">
                    <li class="scroll-to-link " :class="(open == 'auth')?'active':''" data-target="#session-messages">
                        <a @click="(open != 'auth')?open ='auth':open =''">auth <feather type="chevron-down"></feather></a>
                        <ul class="submenu-token">
                          <li class="sublist"><a href="#"  @click.prevent="type='auth'" v-html="$t('getToken')"></a></li>
                        </ul>
                    </li>
                    <li class="scroll-to-link " :class="(open == 'account')?'active':''" data-target="#session-messages">
                        <a @click="(open != 'account')?open ='account':open =''">{{$t('account')}} <feather type="chevron-down"></feather></a>
                        <ul class="submenu-token">
                          <li class="sublist"><a href="#" @click.prevent="type='account'; page='accounts'" v-html="$t('getAcc')"></a></li>
                          <li class="sublist"><a href="#"  @click.prevent="type='account'; page='changepassword'" v-html="$t('getChangepassword')"></a></li>
                        </ul>
                    </li>
                    <li class="scroll-to-link " :class="(open == 'market')?'active':''" data-target="#session-messages">
                        <a @click="(open != 'market')?open ='market':open =''">{{$t('market')}} <feather type="chevron-down"></feather></a>
                        <ul class="submenu-token">
                          <li class="sublist"><a href="#" @click.prevent="type='market'" v-html="$t('getSymbols')"></a></li>
                        </ul>
                    </li>
                    <li class="scroll-to-link " :class="(open == 'trading')?'active':''" data-target="#session-messages">
                        <a @click="(open != 'trading')?open ='trading':open =''">{{$t('trading')}} <feather type="chevron-down"></feather></a>
                        <ul class="submenu-token">
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='opentrades'" v-html="$t('getOpentrades')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='openorders'" v-html="$t('gtOpenOrders')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='tradehistory'" v-html="$t('getTadehistory')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='placemarket'" v-html="$t('getPlacemarket')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='placepending'" v-html="$t('getPlacepending')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='placestop'" v-html="$t('getPlacestop')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='placelimit'" v-html="$t('getPlacelimit')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='closetrade'" v-html="$t('getClosetrade')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='modifyorder'" v-html="$t('getModifyorder')"></a></li>
                          <li class="sublist"><a href="#" @click.prevent="type='trading'; page='cancelorder'" v-html="$t('getCancelorder')"></a></li>
                        </ul>
                    </li>
                    <li class="scroll-to-link " :class="(open == 'streaming')?'active':''" data-target="#session-messages">
                        <a @click="(open != 'streaming')?open ='streaming':open =''">{{$t('streaming')}} <feather type="chevron-down"></feather></a>
                        <ul class="submenu-token">
                          <li class="sublist"><a href="#" @click.prevent="type='streaming'" v-html="$t('getWs')"></a></li>
                        </ul>
                    </li>
                    <!-- <li class="scroll-to-link" data-target="#application-messages">
                        <a>account <feather type="chevron-down"></feather></a>
                        <ul class="submenu-token">
                          <li class="sublist"><a href="#">accounts</a></li>
                          <li class="sublist"><a href="#">changepassword</a></li>
                        </ul>
                    </li> -->
                </ul>
            </div>
        </div>
        <div class="content-page">
          <div class="full-length-block">
            <div class="content-code"></div>
            <div class="content">
              <div class="api-information">
                <div class="collection-name">
                  <p class="headTitle">{{$t('FxViewTradAPI')}}</p>
                </div>
                <div class="collection-description"><p>{{$t('apiEndpoints')}} </p>
                  <ol class="orderList">
                    <li>{{$t('RestApi')}} - <a href="http://rest-api.sysfx.com:18001/">http://rest-api.sysfx.com:18001/</a></li>
                    <li>{{$t('WebSocketMsg')}} - ws://stream.sysfx.com:18002/</li>
                  </ol>
                  <p>{{$t('EasternTime')}}</p>
                </div> 
              </div>
            </div>
          </div>
          <!-- all pages -->
          <app-auth v-if="type == 'auth'"></app-auth>

          <app-account :api_name="page" v-if="type == 'account'"></app-account>

          <app-market v-if="type == 'market'"></app-market>

          <app-trading :api_name="page" v-if="type == 'trading'"></app-trading>

          <app-streaming v-if="type == 'streaming'"></app-streaming>  
        </div>
      
    </div>
</template>
<script> 
  // import auth from './api_document/auth'
  import auth from './api_document/auth'
  import account from './api_document/account'
  import market from './api_document/market'
  import trading from './api_document/trading'
  import streaming from './api_document/streaming'
  import { fxViewMixins } from '@/plugins/fxView'
    export default {
      name: 'subscription',
      mixins: [fxViewMixins],
      components:{
        appAuth: auth,
        appAccount: account,
        appTrading: trading,
        appMarket: market,
        appStreaming: streaming
      },
      data() {
        return {
           open:'auth',
           type:'auth',
           page:'Token'
        }
      },
      methods:{
        handleCopy(element) {
            this.selectText(element); // e.g. <div ref="text">
            document.execCommand("copy");
        },
        selectText(element) {
            var range;
            if (document.selection) {
                // IE
                range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(element);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        }
      },
      computed:{
         
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_documentation.vue